import React from 'react'
 
import ServiceOverviews from './ServiceOverviews'

const ServiceTypes = () => {
  return (
    <div>
      {/* <HomeServices/> */}
      <ServiceOverviews/>
    </div>
  )
}

export default ServiceTypes
